import _remove from 'lodash/remove';
import _includes from 'lodash/includes';
import studentLeaveInfoDialogTemplate from '../../../components/student-leave-info/student-leave-info.html';
import {stringTool} from '../../../util/string-tool.js';

export default class UnregisterStudentController {
  /** @ngInject */
  constructor(
    $log, $rootScope, $mdDialog, $mdToast, $document,
    attendances,
    categoriesOfDeparture,
    departureCategory,
    comment,
    moment,
    StudentService,
    EmployeeService
  ) {
    this.$log = $log;
    this.$rootScope = $rootScope;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$document = $document;
    this.attendances = attendances;
    this.categoriesOfDeparture = categoriesOfDeparture;
    this.departureCategory = departureCategory;
    this.moment = moment;
    this.StudentService = StudentService;
    this.EmployeeService = EmployeeService;
    this.StringTool = stringTool;
    this.attendance = {
      comment: comment || ''
    };
    this.employees = [];
    this.date = new Date();
    this.time = moment().format('HH:mm');
  }

  unregister(form) {
    if (form.$invalid) {
      return false;
    }

    this.editAttendances(this.attendances).then(() => {
      this.$mdDialog.hide(this.attendance);
    })
      .catch(error => {
        this.$mdDialog.cancel();
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  editAttendances(attendances) {
    this.attendance.date = attendances[0].date;
    this.attendance.endTime = this.time;
    this.attendance.categoryOfDepartureId = this.departureCategory;
    if (Number(this.attendance.categoryOfDepartureId) === 2) {
      this.attendance.receivingEmployeeId = Number(this.selectedEmployee.id);
    }

    this.attendance.attendances = attendances;
    const attendancesId = [];
    this.attendance.attendances.forEach(attendance => {
      attendancesId.push(Number(attendance.id));
    });
    this.attendance.attendancesId = attendancesId;
    return this.StudentService.closeAttendance(this.attendance);
  }

  loadEmployees() {
    this.EmployeeService.getSchoolCommonRoomActiveEmployees(0, true).then(result => {
      result.map(employee => {
        employee.firstNameValue = employee.firstName.toLowerCase();
        employee.firstNameValue = this.StringTool.escapePolishCharacters(employee.firstNameValue);
        employee.lastNameValue = employee.lastName.toLowerCase();
        employee.lastNameValue = this.StringTool.escapePolishCharacters(employee.lastNameValue);
        employee.fullNameValue = employee.fullName.toLowerCase();
        employee.fullNameValue = this.StringTool.escapePolishCharacters(employee.fullNameValue);
        return employee;
      });
      this.employees = result;
      const employeesId = [];
      this.attendances.map(attendance => {
        employeesId.push(attendance.employee.id);
        return attendance;
      });
      if (_includes(employeesId, this.$rootScope.me.employeeId)) {
        _remove(this.employees, employee => Number(employee.id) === this.$rootScope.me.employeeId);
      }
    });
  }

  querySearch(query) {
    return query ? this.employees.filter(this.createFilterFor(query)) : this.employees;
  }

  createFilterFor(query) {
    let result = true;
    const lowercaseQuery = query.toLowerCase();
    return employee => {
      if (employee.lastNameValue.search(lowercaseQuery) === 0) {
        result = (employee.lastNameValue.search(lowercaseQuery) === 0);
      } else {
        result = (employee.firstNameValue.search(lowercaseQuery) === 0);
      }

      return result;
    };
  }

  showStudentLeaveInfo(student, event) {
    event.stopPropagation();

    this.$mdDialog.show({
      bindToController: true,
      controller: 'StudentLeaveInfoController',
      controllerAs: 'ctrl',
      template: studentLeaveInfoDialogTemplate,
      disableParentScroll: true,
      targetEvent: event,
      locals: {student},
      multiple: true
    });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
